import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO33 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK003-3.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO33
